// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-container {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 250px;
  border-color: #4b5563;
}

.carousel-track {
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  width: 1400%;
  height: 100%;
  gap: 16px;
  animation: scroll 60s linear infinite;
}

.carousel-card {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px; /* Default width for mobile */
  height: 100%;
  border-radius: 20%;
  background: rgb(255, 255, 255);
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.carousel-card > img {
  height: 90%;
  width: 90%;
  border-radius: 10%;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@media (min-width: 640px) {
  .carousel-card {
    width: 350px;
  }

  .carousel-track {
    width: 800%;
  }
}

@media (min-width: 768px) {
  .carousel-card {
    width: 400px;
  }
  .carousel-track {
    width: 600%;
  }
}

@media (min-width: 1024px) {
  .carousel-container {
    height: 300px;
  }

  .carousel-card {
    width: 500px;
  }
  .carousel-track {
    width: 450%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/css/Autoplaycarousel.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY,EAAE,6BAA6B;EAC3C,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B;;wBAEsB;AACxB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF","sourcesContent":[".carousel-container {\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  height: 250px;\n  border-color: #4b5563;\n}\n\n.carousel-track {\n  display: flex;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 1400%;\n  height: 100%;\n  gap: 16px;\n  animation: scroll 60s linear infinite;\n}\n\n.carousel-card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 500px; /* Default width for mobile */\n  height: 100%;\n  border-radius: 20%;\n  background: rgb(255, 255, 255);\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.carousel-card > img {\n  height: 90%;\n  width: 90%;\n  border-radius: 10%;\n}\n\n@keyframes scroll {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n@media (min-width: 640px) {\n  .carousel-card {\n    width: 350px;\n  }\n\n  .carousel-track {\n    width: 800%;\n  }\n}\n\n@media (min-width: 768px) {\n  .carousel-card {\n    width: 400px;\n  }\n  .carousel-track {\n    width: 600%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .carousel-container {\n    height: 300px;\n  }\n\n  .carousel-card {\n    width: 500px;\n  }\n  .carousel-track {\n    width: 450%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
